
export default function addModalUrlAutoComplete(wpcfModalSelector){
    const urlParams = new URLSearchParams(window.location.search);

    if (`#modal${urlParams.get('modal')}` == wpcfModalSelector) {
        let modalAutoCompeteData = {
            'modal-disabled': {},
            'modal-autocomplete' : {}
        };

        $(`#modal${urlParams.get('modal')}`).modal('show');

        for (let p of urlParams) {
            if(p[0].match(/disabled/)){
                let key = p[0].replace(/-disabled/, '');
                modalAutoCompeteData['modal-disabled'][key] = p[1];
            }else{
                let key = p[0];
                modalAutoCompeteData['modal-autocomplete'][key] = p[1];
            }
        }

        sessionStorage.setItem(`#modal${urlParams.get('modal')}`, JSON.stringify(modalAutoCompeteData));
        $(`#modal${urlParams.get('modal')}`).modal('show');
    }
}